import React from 'react';
import { BlogCard } from './BlogCard';
import { BlogCardSkeleton } from './BlogCardSkeleton';
import { ErrorAlert } from '../shared/ErrorAlert';
import type { BlogPost } from '../../types/blog';

interface BlogGridProps {
  posts: BlogPost[];
  isLoading: boolean;
  isError: boolean;
  onRetry?: () => void;
}

export function BlogGrid({ posts, isLoading, isError, onRetry }: BlogGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <BlogCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (isError) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <ErrorAlert 
          message="Failed to load blog posts" 
          onRetry={onRetry}
        />
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No blog posts found</p>
        <p className="text-gray-400 text-sm mt-2">
          Try adjusting your filters or check back later for new content
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post) => (
        <BlogCard key={post.id} post={post} />
      ))}
    </div>
  );
}